import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

const GarrisonListService = {
    apply: async (payload) => axios.post(API_URL + "/garrison_list/apply", payload).then(({ data }) => data).catch((err) => { throw err }),

    openGarrisonLocation: (id, dtStart, dtEnd) => `${BASENAME}reports/garrison_location_map?garrisonId=${id}&dtStart=${dtStart}&dtEnd=${dtEnd}`,

    garrisonHref: (id) => `${BASENAME}${API_DESPACHO_WEB}/garrison/form/${id}`,
}

export default GarrisonListService;